/** localStorage key: org invite token preserved from signup → verify-email → /join */
export const PENDING_ORG_INVITE_TOKEN_KEY = 'rithmo_pending_org_invite_token'
